import { useMemo } from 'react';
import { TrackingForecastPreferenceParams } from 'types/Meteorology/Fields/TrackingForecast/DetailedView/preference';
import { parse } from 'date-fns';
import formatDateDifference from 'helper/formatDateDifference';
import useChartDataParams from './useChartDataParams';

export default function usePreferenceParams() {
  const chartDataParams = useChartDataParams();

  const params: TrackingForecastPreferenceParams | undefined = useMemo(() => {
    if (chartDataParams === undefined) {
      return undefined;
    }

    const {
      subpage,
      timeFrequency,
      variable,
      locationId,
      locationIds,
      memberIds,
      modelIds,
      forecastDates,
    } = chartDataParams;
    const baseParams = {
      timeFrequency,
      variable,
    };
    const dateDiffs = forecastDates.map((dateString) => {
      const date = parse(dateString, 'yyyy-MM-dd', new Date());
      return formatDateDifference(date, [new Date()], false) as string;
    });

    switch (subpage) {
      case 'locations': return {
        ...baseParams,
        locationIds,
        modelId: modelIds[0],
        forecastDate: dateDiffs[0],
      };
      case 'members': return {
        ...baseParams,
        locationId,
        memberIds,
        modelId: modelIds[0],
        forecastDate: dateDiffs[0],
      };
      case 'models': return {
        ...baseParams,
        locationId,
        modelIds,
        forecastDate: dateDiffs[0],
      };
      case 'rounds': return {
        ...baseParams,
        locationId,
        modelId: modelIds[0],
        forecastDates: dateDiffs,
      };
      default: return undefined;
    }
  }, [chartDataParams]);

  return params;
}
